"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cercivento": {
    "eeffb25f": [{
      "hkey": "6b42be06",
      "slug": "cercivento",
      "name": "Cercivento",
      "primary": true,
      "skipSearch": false
    }],
    "borgate-dei-casali-vidal": [{
      "hkey": "6b42be06",
      "slug": "cercivento",
      "name": "Cercivento",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cf1e8e47": [{
      "hkey": "6b42be06",
      "slug": "cercivento",
      "name": "Cercivento",
      "primary": true,
      "skipSearch": false
    }],
    "cercivento-di-sopra": [{
      "hkey": "6b42be06",
      "slug": "cercivento",
      "name": "Cercivento",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ba91cc63": [{
      "hkey": "6b42be06",
      "slug": "cercivento",
      "name": "Cercivento",
      "primary": true,
      "skipSearch": false
    }],
    "cercivento-di-sotto": [{
      "hkey": "6b42be06",
      "slug": "cercivento",
      "name": "Cercivento",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "07c55387": [{
      "hkey": "6b42be06",
      "slug": "cercivento",
      "name": "Cercivento",
      "primary": true,
      "skipSearch": false
    }],
    "chiandelin": [{
      "hkey": "6b42be06",
      "slug": "cercivento",
      "name": "Cercivento",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c84ff309": [{
      "hkey": "6b42be06",
      "slug": "cercivento",
      "name": "Cercivento",
      "primary": true,
      "skipSearch": false
    }],
    "fascin": [{
      "hkey": "6b42be06",
      "slug": "cercivento",
      "name": "Cercivento",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1efa899a": [{
      "hkey": "6b42be06",
      "slug": "cercivento",
      "name": "Cercivento",
      "primary": true,
      "skipSearch": false
    }],
    "queste": [{
      "hkey": "6b42be06",
      "slug": "cercivento",
      "name": "Cercivento",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;